import { gql, TypedDocumentNode } from '@apollo/client'
import { workObstructionFragment } from './WorkObstructionFragment'
import type { WorkdayFragment } from './__generated__/WorkdayFragment'

export const workdayFragment: TypedDocumentNode<WorkdayFragment> = gql`
  ${workObstructionFragment}

  fragment WorkdayFragment on Workday {
    breakInMinutes
    cancellationRequestState
    endsAt
    id
    startsAt
    workObstruction {
      ...WorkObstructionFragment
    }
  }
`
